import React from "react";
import PropTypes from "prop-types";
import SelectInput from "../../../common/forms/SelectInput";

const ConsultantFNFilter = React.forwardRef((props, ref) => {
  return (
    <SelectInput default="All" label="First Name" onChange={props.onChange} options={props.names.sort()} ref={ref} />
  );
});

ConsultantFNFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  names: PropTypes.array.isRequired,
};

export default React.memo(ConsultantFNFilter);
